import { showErrorNotification, showSuccessNotification } from '../../global/notifications';

export const deriveRole = ($btn) => $btn.data('role-key');
export const shouldTriggerReload = ($btn) => $btn.data('trigger-reload') === true;
export const isFinalSection = ($btn) => $btn.data('section') === 'final';

let _id = null;

export default function(id) {
    _id = id;

    attachApproveEvent();
    attachRejectionEvent();
}

const attachApproveEvent = () => {
    const $approveButton = $('[data-role="approve"]');

    $approveButton.bind('click', function(e) {
        const $this = $(this);
        $this.attr('disabled', true);
        const $pin = $('[id^="pin_id_"]');
        const role = deriveRole($this);
        if (role === 'project_manager') clickSave();
        savePercentages();
        approveBaselineSignOff($this, role, $pin.val())
            .then(message => showSuccessNotification(message))
            .then(_ => attachApproveEvent())
            .then(_ => attachRejectionEvent())
            .then(_ => { if (shouldTriggerReload($this)) window.location.reload(); })
            .catch(error => showErrorNotification(error))
            .finally(() => {
                $this.attr('disabled', false);
                $.event.trigger('on:UiUpdate');
            });
    });
};

const savePercentages = () => {
    const $percentages = $('input.js-percent.js-share-percent[data-role="numerictextbox"]');
    $.each($percentages, (index, element) => {
        const $percentage = $(element);
        const k_percentage = $percentage.data('kendoNumericTextBox');

        if (k_percentage) {
            k_percentage.trigger('change');
        }
    });
};

const clickSave = () => {
    $('#saveButton').click();
};

const approveBaselineSignOff = ($approveBtn, role, pin) => {
    return new Promise((resolve, reject) => {
        const data = {
            id: _id,
            role: role,
            pin: pin,
        };
        $.post('/Operations/ProfitShare/ApproveSignOff', data, function(response) {
            if (typeof response === 'object') {
                if (response.success) resolve(response.message);
                else reject(response.message);
            } else {
                let $container = $('.js-baseline-sign-off');
                if (isFinalSection($approveBtn)) {
                    $container = $('.final-project-sign-offs');
                }
                $container.html(response);
                $('[name="IsApproved"]').val('true');
                resolve('Successfully approved');
            }
        });
    });
};

const attachRejectionEvent = () => {
    attachRejectionEventHelper('[data-role="baseline-reject"]', '[name="baseline_comment"]');
    attachRejectionEventHelper('[data-role="final-reject"]', '[name="final_comment"]');
};

const attachRejectionEventHelper = (rejectionButtonSelector, commentSelector) => {
    const $rejectButton = $(rejectionButtonSelector);

    $rejectButton.bind('click', function(e) {
        const $this = $(this);
        $this.attr('disabled', true);
        const $comment = $(commentSelector);
        const role = $comment.attr('name').trim();

        rejectSignOff(role, $comment.val())
            .then(message => showSuccessNotification(message))
            .then(_ => window.location.reload())
            .catch(error => showErrorNotification(error))
            .finally(() => {
                $this.attr('disabled', false);
                $.event.trigger('on:UiUpdate');
            });
    });
};

const rejectSignOff = (role, comment) => {
    return new Promise((resolve, reject) => {
        const data = {
            id: _id,
            role: role,
            comment: comment,
        };

        if (comment === '') {
            reject('Comment is required for rejection');
            return;
        }

        $.post('/Operations/ProfitShare/RejectSignOff', data, function(response) {
            if (typeof response === 'object') {
                if (response.success) resolve(response.message);
                else reject(response.message);
            } else {
                let $container = $('.js-baseline-sign-off');
                if (role === 'final_comment') {
                    $container = $('.final-project-sign-offs');
                }
                $container.html(response);
                $('[name="IsApproved"]').val('true');
                resolve('Successfully Rejected');
            }
        });
    });
};
